import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';

const PROVIDER_ICONS = { microsoft: '🪟', google: '✉️' };

function statusClass(account) {
  if (account.status === 'expired') return ' expired';
  if (account.token_expiring_soon) return ' expiring';
  return '';
}

function statusBadge(account) {
  if (account.status === 'active' && account.token_expiring_soon)
    return <span className="badge badge-warning" style={{ fontSize: 10 }}>Expiring</span>;
  if (account.status === 'active')
    return <span className="badge badge-success" style={{ fontSize: 10 }}>● Active</span>;
  if (account.status === 'expired')
    return <span className="badge badge-danger" style={{ fontSize: 10 }}>● Expired</span>;
  if (account.status === 'suspended')
    return <span className="badge badge-warning" style={{ fontSize: 10 }}>Suspended</span>;
  return <span className="badge badge-neutral" style={{ fontSize: 10 }}>{account.status}</span>;
}

export default function EmailAccountCard({ account, onDisconnect, onReconnect }) {
  const navigate = useNavigate();
  const synced = account.last_synced_at
    ? formatDistanceToNow(new Date(account.last_synced_at), { addSuffix: true })
    : 'Never';

  return (
    <div className={`account-card compact${statusClass(account)}`} style={{
      padding: '10px 14px',
      display: 'flex',
      alignItems: 'center',
      gap: 10,
    }}>
      <span style={{ fontSize: 20, lineHeight: 1 }}>{PROVIDER_ICONS[account.provider] || '📧'}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 600, fontSize: 13, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {account.display_name || account.email}
        </div>
        <div style={{ fontSize: 11, color: 'var(--text3)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {account.email} · Synced {synced}
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 5, flexShrink: 0 }}>
        {statusBadge(account)}
        {account.status === 'active' && (
          <button className="btn btn-ghost btn-sm" style={{ fontSize: 11, padding: '2px 8px' }}
            onClick={() => navigate(`/email/${account.id}`)}>
            Open ↗
          </button>
        )}
        {(account.status === 'expired' || account.token_expiring_soon) && (
          <button className="btn btn-success btn-sm" style={{ fontSize: 11, padding: '2px 8px' }}
            onClick={() => onReconnect(account)}>
            Reconnect
          </button>
        )}
        <button
          onClick={() => onDisconnect(account)}
          title="Remove account"
          style={{
            background: 'none', border: '1px solid var(--danger)', color: 'var(--danger)',
            borderRadius: 4, cursor: 'pointer', fontSize: 11, padding: '1px 6px', lineHeight: '18px',
          }}>
          ✕
        </button>
      </div>
    </div>
  );
}
